import React, { FC, ReactElement, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { clearAuthInfoFromStorage, clearStorage, userInGroup } from '../../../util';

interface AuthorizedUserType {
  allowedUserGroups: string[];
  children: React.ReactNode;
}

const AuthorizedUser: FC<AuthorizedUserType> = (props: AuthorizedUserType): ReactElement => {
  const { children, allowedUserGroups } = props;
  const isUserAllowed = userInGroup(allowedUserGroups);
  useEffect(() => {
    if (!isUserAllowed) {
      clearAuthInfoFromStorage();
      clearStorage();
    }
  }, [isUserAllowed]);
  return (
    <>
      {isUserAllowed ? (
        children
      ) : (
        <div className="row d-flex justify-content-center text-center ">
          <div className="col-md-12 container">
            <Alert variant="danger">
              <h3 className="d-flex justify-content-center text-center">
                Unauthorized access. Please contact system admin
              </h3>
            </Alert>
          </div>
        </div>
      )}
    </>
  );
};

export default AuthorizedUser;
